export default "__VITE_ASSET__eyNOOPH7__"